module.exports = __webpack_public_path__ + "img/icon50.f4d6be83.png";